module.exports = __webpack_public_path__ + "media/brands/lamberet-f1ce2b99.png";